import { Box } from "@mui/material";
import {
	CheckYourSearchSpellingText,
	NoOrdersFoundFirstBullet,
	NoOrdersFoundHeader,
	NoOrdersFoundSecondBullet,
	PleaseContactSalesRepText,
	ToSeeOrderOnListText
} from "constants/text";
import styles from "containers/Orders/order-styles.module.css";

const NoOrdersErrorBanner = () => {
	return (
		<div className={styles.noOrdersErrorBannerContainer}>
			<Box maxWidth="366px">
				<img
					src="/assets/NoOrdersSadBoxImage.svg"
					alt="No Orders Banner"
					className={styles.noOrdersErrorBannerContainerImage}
				/>
				<h5>{NoOrdersFoundHeader}</h5>
				<p>{ToSeeOrderOnListText}</p>
				<ul>
					<li>{NoOrdersFoundFirstBullet}</li>
					<li>{NoOrdersFoundSecondBullet}</li>
					<li>{CheckYourSearchSpellingText}</li>
				</ul>
				<p>{PleaseContactSalesRepText}</p>
			</Box>
		</div>
	);
};

export default NoOrdersErrorBanner;
